import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";

export const AddChildStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
    container: {
        ...OnboardingStyle(theme).container,
        padding: theme.spacing(6.25, 3.5),
    },
    topBar: {
        ...OnboardingStyle(theme).topBar,
        padding: theme.spacing(0, 2.75),
    },
    topContent: {
        ...OnboardingStyle(theme).topContent,
        padding: theme.spacing(0, 2.75),
    },
    form: {
        ...OnboardingStyle(theme).form,
        gap: theme.spacing(3.75),
    },
    formMiddleContent: {
        ...OnboardingStyle(theme).formMiddleContent,
        gap: theme.spacing(3.75),
    },
    formBottomContent: {
        ...OnboardingStyle(theme).formBottomContent,
        padding: theme.spacing(0, 2.75),
    },
    childCard: {
        borderRadius: '0.1875rem',
        position: 'relative',
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
        padding: theme.spacing(2, 2.5, 3.5),
        marginBottom: '25px',
    },
    deleteChildButton: {
        position: 'absolute',
        bottom: '-25px',
        right: '5px',
    },
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepAddChild/addChild.styles.ts